import axios from 'axios';

const baseUrl = process.env.REACT_APP_BACKEND_URL;

const getPublicProfile = async (profileData) => {
    const url = `${baseUrl}/api/publicProfiles/getPublicProfile`;

    return (await axios.post(url, profileData)).data;
};

const publicProfileService = {
    getPublicProfile,
};

export default publicProfileService;